import { Descendant } from 'slate';

// models
import { ElementKind } from '../../../../../models/editor.model';

export const getUpdatedFormulaStructure = (
    newMasterVariant: string,
    variantId: string,
    currentStructure?: Descendant[],
) => {
    // deep clone of current formula structure
    const formulaStructure: any = JSON.parse(JSON.stringify(currentStructure));
    currentStructure?.forEach((section: any, sectionIndex: number) => {
        if (
            section?.variantType === ElementKind.image &&
            section.id === variantId
        ) {
            formulaStructure[sectionIndex].children[0].text = newMasterVariant;
            return;
        }
        section.children.forEach((children: any, childrenIndex: number) => {
            if (
                children.kind === ElementKind.variant &&
                children.id === variantId
            ) {
                formulaStructure[sectionIndex].children[
                    childrenIndex
                ].children[0].text = newMasterVariant;
                return;
            }
        });
    });
    return formulaStructure;
};
